export default __webpack_public_path__ + "static/media/Terminos_Condiciones.e3f249cd.pdf";